import {SUPPORTS_SYMBOL} from "./constructor";

export const SUPPORTS_SYMBOL_MATCH_ALL = SUPPORTS_SYMBOL && "matchAll" in Symbol;
